<template>
  <v-card class="mx-auto">
    <v-toolbar color="indigo" height="50" dark>
      <v-icon>mdi-face-agent</v-icon>

      <v-toolbar-title class="text-body-1 ml-3">{{$t('DESTEK.DASHBOARD.LAST_TICKETS.TITLE')}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn color="transparent" depressed>
        <v-icon left size="22">mdi-checkbox-marked-circle</v-icon>
        {{$t('DESTEK.DASHBOARD.LAST_TICKETS.IN_PROGRESS')}}
      </v-btn>
    </v-toolbar>

    <v-list two-line>
      <v-list-item-group v-model="selected" active-class="blue--text" multiple>
        <template v-for="(item, index) in yeniSiparisler">
          <v-list-item :key="item.title">
            <template v-slot:default="{ active }">
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>

                <v-list-item-subtitle class="text--primary" v-text="item.headline"></v-list-item-subtitle>

                <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon class="px-5 d-flex align-center">
                <v-list-item-subtitle class="">
                  {{$t('DESTEK.DASHBOARD.LAST_TICKETS.AMOUNT')}}:
                  <strong>{{$t('DESTEK.DASHBOARD.LAST_TICKETS.PRICE_FORMAT', { QUANTITY: 300 })}}</strong>
                </v-list-item-subtitle>
              </v-list-item-icon>

              <v-list-item-action>
                <v-btn small depressed color="indigo" dark class="text-capitalize" :class="[active ? '' : '']">
                  <v-icon left>mdi-magnify</v-icon>
                  {{$t('DESTEK.DASHBOARD.LAST_TICKETS.REVIEW_BTN')}}
                </v-btn>

                <!-- <v-icon v-if="!active" color="grey lighten-1">mdi-star-outline</v-icon>

                <v-icon v-else color="yellow darken-3">mdi-star</v-icon>-->
              </v-list-item-action>
            </template>
          </v-list-item>
          <v-divider v-if="index < yeniSiparisler.length - 1" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
const randomHeadlines = {};

randomHeadlines["tr-TR"] = [
  "Ürün teslimatı gecikti",
  "Ürün kalitesi hakkında soru",
  "İade talebi",
  "Destek hattı ile iletişim kuramıyorum",
  "Ürün montajında yardıma ihtiyacım var",
  "Garanti süresi uzatma talebi"
];

randomHeadlines["en-US"] = [
  "Product delivery delayed",
  "Question about product quality",
  "Return request",
  "Unable to reach support line",
  "Need assistance with product assembly",
  "Request to extend warranty period"
];

const maleNames = [
  "James",
  "John",
  "Robert",
  "Michael",
  "William",
  "David",
  "Richard",
  "Joseph",
  "Charles",
  "Thomas",
  "Christopher",
  "Daniel",
  "Matthew",
  "Donald",
  "Anthony",
  "Paul",
  "Mark",
  "George",
  "Steven",
  "Kenneth"
];

const femaleNames = [
  "Mary",
  "Patricia",
  "Jennifer",
  "Linda",
  "Elizabeth",
  "Barbara",
  "Susan",
  "Jessica",
  "Sarah",
  "Karen",
  "Nancy",
  "Lisa",
  "Betty",
  "Margaret",
  "Sandra",
  "Ashley",
  "Dorothy",
  "Emily",
  "Donna",
  "Michelle"
];

function getRandomName(names) {
  const randomIndex = Math.floor(Math.random() * names.length);
  return names[randomIndex];
}

export default {
  name: "NewTickets",

  data() {
    return {
      selected: [],
      yeniSiparisler: [
        {
          action: "15 min",
          headline: randomHeadlines[this.$store.state.Language.apiLanguage][0],
          subtitle: "",
          title: getRandomName(maleNames)
        },
        {
          action: "15 min",
          headline: randomHeadlines[this.$store.state.Language.apiLanguage][1],
          subtitle: "",
          title: getRandomName(maleNames)
        },
        {
          action: "15 min",
          headline: randomHeadlines[this.$store.state.Language.apiLanguage][2],
          subtitle: "",
          title: getRandomName(maleNames)
        },
        {
          action: "15 min",
          headline: randomHeadlines[this.$store.state.Language.apiLanguage][3],
          subtitle: "",
          title: getRandomName(maleNames)
        },
        {
          action: "15 min",
          headline: randomHeadlines[this.$store.state.Language.apiLanguage][4],
          subtitle: "",
          title: getRandomName(maleNames)
        }
      ]
    };
  }
};
</script>

<style scoped></style>
